import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'How do I register my child for summer camp?',
  answer: 'The easiest way to register is to text or call Megan directly at 517-225-9501. You can also email megan@stormtaekwondo.com to get started.'
}, {
  question: 'Is there a capacity limit?',
  answer: 'No set limit. If more campers sign up, additional helpers will be added to keep the group well-supervised. Reach out early to lock in your spot.'
}, {
  question: 'What age is Storm Summer Camp for?',
  answer: 'Camp is open to kids ages 6 and up.'
}, {
  question: 'What time is summer camp?',
  answer: 'Camp runs Monday through Friday from 10:00 AM to 4:00 PM.'
}, {
  question: 'Can my child be dropped off early?',
  answer: 'No, there is no early drop-off. Please plan to arrive at the start of the camp day at 10:00 AM.'
}, {
  question: 'What if I am running late for pickup?',
  answer: 'Late pickup is fine. Campers can hang out until parents arrive, and Storm holds regular classes immediately after camp ends.'
}, {
  question: 'How does payment work? Can I pay by the day?',
  answer: 'You pay one week at a time, but there is also an option to pay by the day. Text or call 517-225-9501 to discuss what works best for your family.'
}, {
  question: 'Are camp shirts included?',
  answer: 'Yes! A Storm Taekwondo camp shirt is included for every camper.'
}, {
  question: 'What should my child bring?',
  answer: 'Campers should bring their own lunch, snack, water bottle, and wear comfortable clothes.'
}, {
  question: 'Does my child need Taekwondo experience?',
  answer: 'No experience required. Camp is designed to help kids stay active, make friends, and participate in fun group activities and games at any level. Camp is not a Taekwondo class.'
}, {
  question: 'Where is the camp located?',
  answer: 'Storm Taekwondo is located at 24786 Crestview, Farmington Hills, MI 48335.'
}];
export function SummerCampFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-3177" />;
}